import React from "react";
import { ButtonProps } from "../../../types";
import "./Button.css";

const Button: React.FC<ButtonProps> = ({
  children,
  type = "button",
  variant = "primary",
  size = "medium",
  className = "",
  disabled = false,
  onClick,
  style,
  ...props
}) => {
  return (
    <button
      type={type}
      className={`common-btn btn-${variant} btn-${size} ${className}`}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

